




































import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'

@Component({
	components: {
		InfoButton
	}
})
export default class SelectCrime extends GlobalMixins {
	selectedCrime: string | false = false

	@Watch('selectedCrime')
	onSelectedCrimeChange(): void {
		if (this.selectedCrime) {
			this.$store.dispatch('setSelectedCrime', this.selectedCrime)

			bus.$emit('setNextButton', 'next')
		} else {
			bus.$emit('setNextButton', false)
		}
	}

	mounted() {
		bus.$emit('setNextButton', false)
		bus.$on('goToNextScreen', () => {
			let selectedCrimeTitle = ''

			this.$store.getters.crimes.forEach((crime: any) => {
				if (crime.value === this.selectedCrime) selectedCrimeTitle = crime.name[this.language]
			})

			if(selectedCrimeTitle) {
				_paq.push(['trackEvent', 'keuzeDelict', selectedCrimeTitle])
			}
			
			this.$router.push({ name: this.language === Languages.NL ? 'select-punishment' : 'select-punishment-'+this.language })
		})

		if (this.$store.getters.user.selectedCrime) {
			this.selectedCrime = this.$store.getters.user.selectedCrime
		}
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
	}
	
	focus(index: number) {
		if(this.$store.getters.crimes[index]) {
			const crimeEl = document.querySelector("#crime-"+index)
			if(crimeEl) {
				(crimeEl as HTMLElement).focus();
				(crimeEl as HTMLElement).click();
			}
		}
	}
}
